<template>
  <div class="apex-chart-wrapper">
    <apexchart type="line" :series="seriesData" :options="chartOptions"/>
  </div>
</template>

<script>
const TONAL_TEST_MEASUREMENT_TYPE_ID = 9000
const BLOOD_PRESSURE_MEASUREMENT_TYPE_ID = 2
const OXIMETRY_MEASUREMENT_TYPE_ID = 18
const SPIROMETRY_MEASUREMENT_TYPE_ID = 11
const TEMPERATURE_MEASUREMENT_TYPE_ID = 3
const BODY_COMPOSITION_MEASUREMENT_TYPE_ID = 5
const SARCOPENIA_MEASUREMENT_TYPE_ID = 6001
const FRAILTY_PHENOTYPE_TYPE_ID = 6000
const GLUCOSE_MEASUREMENT_TYPE_ID = 4
const CHOLESTEROL_MEASUREMENT_TYPE_ID = 10000
const MAPA_24_MEASUREMENT_TYPE_ID = 20

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
  },
  methods: {
    handleColorBasedOnType: function(typeId){
      const colors = {
        62: '#2391de',
        63: '#49dfb8',
        64: '#ea9665',
        65: 'rgb(86,135,124)',
        66: '#b79e3d',
        67: '#775DD0',
        68: '#520e0a',
        6006: '#49dfb8',
        6011: '#aad05d',
        6013: '#4c24d7',
        6014: '#093e6f',
        6015: '#c56ade'

      }

      return colors[typeId] || '#922626'
    }
  },
  computed: {
    chartOptions: function () {
      let categories = []
      let x = []
      if(this.measurement.measurementSeries.length > 0) {
        this.measurement.measurementSeries.forEach(elem => {
          if(elem.measurementValues && elem.measurementValues.length > 0) {
            categories.push(...elem.measurementValues.map(elem => elem.interval))
          }
        })
      }

      let uniqueCategories = [...new Set(categories)];
      let sortedCategories = uniqueCategories.sort((a, b) => a - b);

      /*if(this.measurement.measurementSeries[0] !== null && this.measurement.measurementSeries[0].measurementValues && this.measurement.measurementSeries[0].measurementValues.length > 0) {
        categories = this.measurement.measurementSeries[0].measurementValues.map(elem => elem.interval)
      }*/
      return {
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 50,
          animateGradually: {
            enabled: false,
            delay: 50
          },
          dynamicAnimation: {
            enabled: true,
            speed: 50
          }
        },
        theme: {
          palette: 'palette1'
        },
        xaxis: {
          categories: sortedCategories
        },
        annotations: this.handleAnnotations,
        legend: {
          show: true,
          showForSingleSeries: true,
          position: 'bottom'
        },
        yaxis: {
          title: {
            //text: this.measurement.measurementSeries[0].measurementType.measurementUnits || ''
          }
        }
      }

    },
    seriesData: function () {
      if(this.measurement.measurementSeries === null) {
        return []
      }
      if(this.measurement.measurementType === "mapa24") {
        return this.measurement.measurementSeries.filter(elem => elem.measurementType.name !== 'MAPA_24H_TYPE' && elem.measurementType.name !== 'MAPA_24H_EVENT').map(elem => {
          return {
            name: this.$t(`dashboard_new_evollu.parameters.graphs.legends.${elem.measurementType.name.toLowerCase()}`),
            data: elem.measurementValues.map(value => (value.value !== null && typeof value.value === 'number' ) ? (Number.isInteger(value.value) ? value.value : value.value.toFixed(2)) : value.value),
            color: this.handleColorBasedOnType(elem.typeId)
          }
        })
      }
      return this.measurement.measurementSeries.map(elem => {
        return {
          name: this.$t(`dashboard_new_evollu.parameters.graphs.legends.${elem.measurementType.name.toLowerCase()}`),
          data: elem.measurementValues.map(value => (value.value !== null && typeof value.value === 'number' ) ? (Number.isInteger(value.value) ? value.value : value.value.toFixed(2)) : value.value),
          color: this.handleColorBasedOnType(elem.typeId)
        }
      })
      /*return {
        name: this.$t(`dashboard_new_evollu.parameters.graphs.legends.${elem.measurementType.name.toLowerCase()}`),
        data: elem.measurementValues.map(value => (value.value !== null && typeof value.value === 'number' ) ? (Number.isInteger(value.value) ? value.value : value.value.toFixed(2)) : value.value),
        color: this.handleColorBasedOnType(elem.typeId)
      }*/

    },
    handleAnnotations: function () {
      const MAPA_24H_TYPE_TYPE_ID = 65
      const MAPA_24H_MAP_TYPE_ID = 66
      const MAPA_24H_EVENT_TYPE_ID = 67
      const MAPA_24H_ERROR_TYPE_ID = 68

      if(this.measurement.measurementSeries === null) {
        return {}
      }
      let annot = {
        xaxis:[],
        yaxis:[]
      }
      switch(this.measurement.measurementTypeId) {
        case MAPA_24_MEASUREMENT_TYPE_ID:
          //Handle Mapa 24, first the event ones, vertical bars filled
          const eventAnnot = this.measurement.measurementSeries.find(mes => mes.typeId === MAPA_24H_EVENT_TYPE_ID).measurementValues.filter(elem => elem.value !== null)
          eventAnnot.forEach(elem => {
            annot.xaxis.push({
              x: elem.interval,
              strokeDashArray: 0,
              borderColor: this.handleColorBasedOnType(MAPA_24H_EVENT_TYPE_ID),
              label: {
                borderColor: this.handleColorBasedOnType(MAPA_24H_EVENT_TYPE_ID),
                style: {
                  color: '#fff',
                  background: this.handleColorBasedOnType(MAPA_24H_EVENT_TYPE_ID),
                },
                text: this.$t(`dashboard_new_evollu.parameters.mapa24events.${elem.value}`),
              }
            })
          })

          if(this.measurement.measurementSeries.some(elem => elem.typeId === MAPA_24H_ERROR_TYPE_ID)) {
            const errorAnnot = this.measurement.measurementSeries.find(mes => mes.typeId === MAPA_24H_ERROR_TYPE_ID).measurementValues.filter(elem => elem.value !== null)
            errorAnnot.forEach(elem => {
              annot.xaxis.push({
                x: elem.interval,
                strokeDashArray: 0,
                borderColor: this.handleColorBasedOnType(MAPA_24H_ERROR_TYPE_ID),
                label: {
                  borderColor: this.handleColorBasedOnType(MAPA_24H_ERROR_TYPE_ID),
                  style: {
                    color: '#fff',
                    background: this.handleColorBasedOnType(MAPA_24H_ERROR_TYPE_ID),
                  },
                  text: elem.value,
                }
              })
            })
          }
          break;
        default:
          return {}
      }

      return annot
    }
  }
}
</script>

<style scoped>

</style>
